<template>
  <div>
    <div class="text-center">
      <v-img class="mx-auto mt-10" width="70px" src="@/assets/logo.png"></v-img>
    </div>
    <div class="text-center mt-8">
      <v-icon size="120" color="primary">mdi-check-circle-outline</v-icon>
    </div>
    <div
      class="text-center primary--text font-weight-bold"
      style="font-size: 24px"
    >
      ลงทะเบียนสำเร็จ
    </div>
    <div class="text-center mt-13">
      <v-btn
        @click="$liff.closeWindow()"
        color="grey lighten-1"
        dark
        class="text-capitalize"
        >ปิด</v-btn
      >
      <v-btn
        @click="query.view = 'ScanIMEI'"
        color="primary"
        class="ml-3 text-capitalize"
        >Scan IMEI</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.state.headertext = "";
  },
};
</script>

<style lang="scss" scoped>
</style>